// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as BehaviourMultiChoiceGroupedOptionContainer$LiteracyplanetTupperware from "./BehaviourMultiChoiceGroupedOptionContainer.res.mjs";

function SkilfulMultiChoiceSingleResponseContainer(props) {
  return React.createElement(BehaviourMultiChoiceGroupedOptionContainer$LiteracyplanetTupperware.make, {
              questionIndex: props.questionIndex,
              group: "SingleResponse",
              responseOptionId: props.responseOptionId,
              children: props.children
            });
}

var make = SkilfulMultiChoiceSingleResponseContainer;

var $$default = SkilfulMultiChoiceSingleResponseContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
